// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { DashboardApi } from '../types/dashboard.types';
import { dashboardHttpApi } from './dashboard.api';
import { dashboardMockApi } from './dashboard.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const dashboardApi: DashboardApi = useMock ? dashboardMockApi : dashboardHttpApi;
